import { Button } from "@jds/core";
import { useState, useRef, useCallback } from "react";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import setCanvasPreview from "../ImageCropper/setCanvasPreview";

export const ImageCrop = ({ src, setFileBlod, backFun }) => {
  const [crop, setCrop] = useState(null);
  const imageRef = useRef(null);
  const canvasRef = useRef(null);

  const [val, setVal] = useState(null);
  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const crop = makeAspectCrop(
      {
        unit: "%",
        width: 75,
      },
      1,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };
  function dataURLToBlob(dataURL) {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

  function dataURItoFile(dataURI, filename) {
    // convert base64/URLEncoded data component to raw binary data
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) {
      byteString = atob(dataURI.split(",")[1]);
    } else {
      byteString = unescape(dataURI.split(",")[1]);
    }
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    // create a File object from the typed array
    var temp = new File([ia], filename, { type: mimeString });
    return temp;
  }

  const capturePhoto = useCallback((imageSrc) => {
    let currentDate = new Date();
    let dateTimeString =
      currentDate.getFullYear() +
      String(currentDate.getMonth() + 1).padStart(2, "0") +
      String(currentDate.getDate()).padStart(2, "0") +
      "T" +
      String(currentDate.getHours()).padStart(2, "0") +
      String(currentDate.getMinutes()).padStart(2, "0") +
      String(currentDate.getSeconds()).padStart(2, "0");

    dateTimeString = dateTimeString + ".png";
    var imgFile = dataURItoFile(imageSrc, dateTimeString);
    return imgFile;
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "10px",
          width: "300px",
          marginInline: "auto",
        }}
      >
        <ReactCrop
          crop={crop}
          circularCrop
          keepSelection
          aspect={1}
          minWidth={50}
          onChange={(c) => {
            setCrop(c);
          }}
        >
          <img
            ref={imageRef}
            src={src}
            onLoad={onImageLoad}
            style={
              {
                // Optional image styling
              }
            }
          />
        </ReactCrop>
        <Button
          fullWidth
          kind="primary"
          size="large"
          label="Crop"
          onClick={() => {
            try {
              setCanvasPreview(
                imageRef.current,
                canvasRef.current,
                convertToPixelCrop(
                  crop,
                  imageRef.current.width,
                  imageRef.current.height
                )
              );
              const dataUrl = canvasRef.current.toDataURL();
              const file = capturePhoto(dataUrl);
              const croppedImg = dataURLToBlob(dataUrl);
              const imageURL = URL.createObjectURL(croppedImg);
              setFileBlod(imageURL, file);
              backFun();
            } catch (error) {
              console.log(error);
            }
          }}
        />
      </div>
      {crop && (
        <canvas
          ref={canvasRef}
          style={{
            display: "none",
            objectFit: "contain",
            width: 150,
            height: 150,
          }}
        ></canvas>
      )}
      <img src={val} />
    </>
  );
};
